import Link from './Link'

export * from './LinkWithText'
export * from './LinkWithIcon'
export * from './OptionalLink'
export * from './StyledLink'
export * from './SharpStyledLink'
export default Link
